import React from 'react'
import Smartview from 'widgets/smartviews/Smartview'
import { Translation, Translator } from '@morningtrain/react-translations'
import ForEachItemWithNormOffset from 'pages/app/inventory/norms/ForEachItemWithNormOffset'
import { ForEachModel, FormContext, ReadOnlyCollection } from '@morningtrain/react-resources'
import WhenCategoryHasOffsets from 'pages/app/inventory/norms/WhenCategoryHasOffsets'
import * as Displays from 'support/displays'
import * as UI from 'ui'
import InventoryItemNormSummary from 'widgets/smartviews/inventory/InventoryItemNormSummary'

export default function NormsSummarySmartview ({ form }) {
  return (
    <FormContext.Provider value={form}>
      <Translator namespace='inventory.smartviews.norms_summary'>
        <Smartview header={<Translation name='title' />}>

          <ReadOnlyCollection resourceName='inventory.norms' operationName='overview'>
            <UI.VerticalList>
              <ForEachModel>
                <WhenCategoryHasOffsets>
                  <div>
                    <UI.WithSubtitle>
                      <UI.Text weight='bold'>
                        <Displays.Text name='key' />
                      </UI.Text>
                    </UI.WithSubtitle>
                    <ForEachItemWithNormOffset>
                      <div className='space-y-10'>
                        <InventoryItemNormSummary />
                      </div>
                    </ForEachItemWithNormOffset>
                  </div>
                </WhenCategoryHasOffsets>
              </ForEachModel>
            </UI.VerticalList>
          </ReadOnlyCollection>

        </Smartview>
      </Translator>
    </FormContext.Provider>
  )
}
